import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

import {Tag, Tooltip} from 'antd';

const prefixUrl = "dossier/data/import/"

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const columnsArray = [
    { type: 'selection' },
    {   
        key:'$index', 
        label: '序号',
        width: 80
    },
    {key:'placeOrgName', label: '发文部门'},
    {key:'fileName', label: '所属文件'},
    {key:'filePath', label: '文件路径'},
    {key:'fileResponsiblePersonCode', label: '责任人工号', width: 120},
    {key:'fileResponsiblePersonName', label: '责任人名称', width: 120},
    {key:'realName', label: '上传人'},
    {key:'fileDesc', label: '文件描述'},
    {key:'termName', label: '归档学期/年度', width: 150},
    {key:'lastUpdateTime', label: '上传时间'},
    {type:'action', label: '操作', values: ['read','video','image', 'down', 'file']},
]

const headers = utils.columns(
    [
        { type: 'selection' },
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {key:'createTime', label: '创建时间'},
        {type:'action', label: '操作', values: ['read','video','image', 'down', 'file']}
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(`${prefixUrl}query?` + params.join('&'), keywords)
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = []
        if(extParams) {
            for(let i = 0; i < columnsArray.length; i++) {
                newArray.push(columnsArray[i])
                if(i === 1) {
                    if(extParams.options.length > 0){
                        extParams.options.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value, 
                                width: 120
                            })
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            headers: utils.columns(newArray.length > 0 ? newArray : columnsArray)
        }
    })
    .then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

const removeByIds = (ids) => {
    return fetch.post(`${prefixUrl}deleteByIds`, ids).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const removeByQuery = (keywords) => {
    return fetch.post(`${prefixUrl}deleteByQuery`, keywords).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const getSearchList = (treeId) => {
    return fetch.get(`${prefixUrl}getSearchList/` + treeId)
    .then(response => {
        return response.payload.data;
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

const getUserSelectData = () => {
    const id = DataGrid.selections[0]
    return DataGrid.selectData.find(d => d.value === id)
}

export default {
    getSelection: () => DataGrid.selections,
    getSelectionData,
    getUserSelectData,
    onSelect,
    onSelectData,
    setRefresh,
    querySearch,
    headers,
    removeByIds,
    removeByQuery,
    getSearchList
}